import {DataStatus, FormSubmitHandler, showNotification} from 'platform/components';
import {Show} from 'platform/foundation';

import {isNotNil} from 'ramda-adjunct';

import {
  useGetMercedesNaSkladePlatformQuery,
  useMercedesNaSkladeAuthenticateMutation,
} from '@dms/api/sales';
import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {
  MercedesNaSkladeAuthenticationFormData,
  PlatformAuthenticationFormMercedesNaSklade,
} from './components/PlatformAuthenticationFormMercedesNaSklade';
import {PlatformPhotoSettings} from './components/PlatformPhotoSettings';

export function PlatformSettingsMercedesNaSklade() {
  const branchId = useBranchId();
  const params = {branchId};
  const {data, isLoading, isError} = useGetMercedesNaSkladePlatformQuery({params});
  const [saveAuthentication] = useMercedesNaSkladeAuthenticateMutation();

  const onSubmitCredentials: FormSubmitHandler<MercedesNaSkladeAuthenticationFormData> = (values) =>
    saveAuthentication({
      body: values,
      params,
    })
      .unwrap()
      .then(() => showNotification.success())
      .catch(handleApiError);

  return (
    <Show whenFeatureEnabled={featureFlags.ADVERTISEMENT_GENERAL_SETTINGS}>
      <DataStatus isLoading={isLoading} isError={isError}>
        {isNotNil(data) && (
          <PlatformAuthenticationFormMercedesNaSklade
            platformCode={AdvertisingPlatformCodeEnum.MERCEDES_NA_SKLADE}
            defaultValues={data.credentials}
            onSubmit={onSubmitCredentials}
          />
        )}
        <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.MERCEDES_NA_SKLADE} />
      </DataStatus>
    </Show>
  );
}
